export const validate = (values) => {
  const errors = {};

  if (!values.get('card')) {
    errors.card = 'Required';
  } else if (values.get('card').error) {
    errors.card = values.get('card').error.message;
  }
  if (!values.get('name')) {
    errors.name = 'Required';
  }
  if (!values.get('address')) {
    errors.address = 'Required';
  }
  if (!values.get('city')) {
    errors.city = 'Required';
  }
  if (!values.get('zipCode')) {
    errors.zipCode = 'Required';
  } else if (!(/(^\d{5}$)|(^\d{5}-\d{4}$)/).test(values.get('zipCode'))) {
    errors.zipCode = 'zip code must have exactly 5 digits';
  }

  if (!values.get('state') || values.get('state') === 'placeholder') {
    errors.state = 'Required';
  }
  return errors;
};



// WEBPACK FOOTER //
// ./app/lib/validate.js